<mat-form-field
  class="w-100"
  appearance="outline"
  [matTooltip]="disabledTooltipText | translate"
  [matTooltipDisabled]="!isDisabled"
  [hideRequiredMarker]="hideRequiredMarker"
>
  <mat-label>{{ title | translate }}</mat-label>
  <mat-select
    [formControl]="control"
    [disabled]="isDisabled"
    [multiple]="isMultiple"
    [errorStateMatcher]="errorStateMatcher"
    panelClass="mat-select-panel-tall"
    (selectionChange)="onValueChange($event.value)"
    (keydown)="onSelectField($event)"
    #selectField
  >
    <mat-option *ngIf="hasEmptyOption && !isMultiple" [value]="null">
      {{ "EMPTY_SELECTION" | translate }}
    </mat-option>
    <mat-option
      *ngFor="let kv of enum | keyvalue: originalOrder; let i = index"
      [value]="kv.value"
      [disabled]="limitReached && !selectedValues.includes(kv.value)"
    >
      {{ optionTitlePrefix + kv.value | translate }}
    </mat-option>
  </mat-select>
  <mat-hint>{{ "REQUIRED" | translate }}</mat-hint>
  <mat-error *ngIf="getServerError()">
    {{ getServerError() }}
  </mat-error>
  <mat-error>
    <ng-content></ng-content>
  </mat-error>
</mat-form-field>
<mat-chip-listbox *ngIf="showSelectedLabels && selectedValues.length">
  <mat-chip
    *ngFor="let item of selectedValues"
    class="easy-chip"
    (removed)="removeSelected(item)"
  >
    {{ optionTitlePrefix + item | translate }}
    <button type="button" matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
</mat-chip-listbox>
